import { Col, Row } from "antd";
import { useState } from "react";
import ComponentsList from "./componentList";
import { AddComponent } from "./AddComponents";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { getItemComponentApi } from "../../../api/itemComponent";
import { useMutation } from "react-query";
import { useParams } from "react-router";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

const Components = () => {
  const [tableKey, setTableKey] = useState("");
  const [openComponent, setOpenComponent] = useState(false);
  const [paginatedItemComponent, setPaginatedItemComponent] = useState<any>();
  const { id } = useParams();
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);

  const resetFilters = () => {
    getcomponents({
      itemid: id,
      q: "",
    }).then((res) => {
      setPaginatedItemComponent(res.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getcomponents({
      itemid: id,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedItemComponent(res.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getcomponents({
      itemid: id,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedItemComponent(res.data);
    });
  };
  const getcomponents = async (params: {
    itemid: string | number | undefined;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await ItemComponentMutation(params);
  };

  const {
    mutateAsync: ItemComponentMutation,

    isLoading: isItemComponentLoading,
  } = useMutation("components", getItemComponentApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={14}
          span={4}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenComponent(true)} />
        </Col>
        <Col span={24}>
          <ComponentsList
            ItemComponentMutation={ItemComponentMutation}
            filter={filter}
            paginatedItemComponent={paginatedItemComponent}
            id={id}
            search={search}
            setPaginatedItemComponent={setPaginatedItemComponent}
            isItemComponentLoading={isItemComponentLoading}
          />
        </Col>
      </Row>
      <AddComponent
        openComponent={openComponent}
        setOpenComponent={setOpenComponent}
        ItemComponentMutation={ItemComponentMutation}
        setPaginatedItemComponent={setPaginatedItemComponent}
        filter={filter}
        search={search}
        itemId={id}
      />
    </>
  );
};

export default Components;
